import type { ReactNode } from 'react'
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'
import { TableHead } from '@/components/ui/table'
import { cn } from '@/lib/utils'

export type SortDir = 'asc' | 'desc'

interface SortableHeadProps {
  /** 本列是否为当前排序键 */
  active: boolean
  /** 当前排序方向（active 为 false 时仅作占位） */
  dir: SortDir
  /** 点击表头切换排序 */
  onSort: () => void
  className?: string
  children: ReactNode
}

/** 可点击排序的表头：未激活灰双向箭头，激活后显示升/降箭头（图标风格与业绩页一致） */
export function SortableHead({ active, dir, onSort, className, children }: SortableHeadProps) {
  const Icon = !active ? ArrowUpDown : dir === 'asc' ? ArrowUp : ArrowDown
  return (
    <TableHead
      className={cn('cursor-pointer select-none hover:text-foreground', className)}
      onClick={onSort}
      aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <span className="inline-flex items-center gap-1 whitespace-nowrap">
        {children}
        <Icon className={cn('size-3.5 shrink-0', !active && 'opacity-40')} />
      </span>
    </TableHead>
  )
}
